export default __webpack_public_path__ + "static/media/coop-internazionale-wallpaper.b1cd5e74.jpg";